import { render } from "./CouponGrantResult.vue?vue&type=template&id=aa0ad156&scoped=true&ts=true"
import script from "./CouponGrantResult.vue?vue&type=script&lang=ts"
export * from "./CouponGrantResult.vue?vue&type=script&lang=ts"

import "./CouponGrantResult.vue?vue&type=style&index=0&id=aa0ad156&scoped=true&lang=css"

import exportComponent from "C:\\Users\\hori_taiki\\Desktop\\小野写真館\\環境構築\\point-front-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa0ad156"]])

export default __exports__